import React from 'react'
import DesktopNavigationListSubSection from '../DesktopNavigationListSubSection'
import { DepartmentNavigationSubSectionFragment } from '#src/generated/graphql'
import DepartmentNavigationLink from '../../common/DepartmentNavigationLink'
import ArrowIcon from './arrow.svg'
import styles from './styles.css'

interface DesktopNavigationSubSectionProps {
  section: DepartmentNavigationSubSectionFragment
  onLinkClick?: React.MouseEventHandler
}

const DesktopNavigationSubSectionTitle: React.SFC<DesktopNavigationSubSectionProps> = ({
  section,
  onLinkClick
}) => {
  return (
    <div className={styles.sectionHeader}>
      {section.titleLink ? (
        <DepartmentNavigationLink
          link={section.titleLink}
          className={styles.sectionHeaderLink}
          onClick={onLinkClick}
        >
          {section.title}
          <ArrowIcon className={styles.arrowIcon} />
        </DepartmentNavigationLink>
      ) : (
        <span>{section.title}</span>
      )}
    </div>
  )
}

const DesktopNavigationSubSectionContent: React.SFC<DesktopNavigationSubSectionProps> = ({
  section,
  onLinkClick
}) => {
  switch (section.__typename) {
    case 'DepartmentNavigationListSubSection':
      return (
        <>
          <DesktopNavigationSubSectionTitle section={section} onLinkClick={onLinkClick} />
          <DesktopNavigationListSubSection section={section} onLinkClick={onLinkClick} />
        </>
      )
    default:
      return null
  }
}

const DesktopNavigationSubSection: React.SFC<DesktopNavigationSubSectionProps> = ({
  section,
  onLinkClick
}) => {
  // TODO: If <DesktopNavigationSubSectionContent> renders null, this section is still rendered
  //   which messes up the the flexbox layout
  return (
    <div className={styles.section}>
      <DesktopNavigationSubSectionContent section={section} onLinkClick={onLinkClick} />
    </div>
  )
}

export default DesktopNavigationSubSection
